import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import config from '../config/config'

export function createWidgetRouter(routes: RouteRecordRaw[]) {
  return createRouter({
    history: createWebHistory(config.baseUrl),
    routes
  })
}
